import React from "react";

interface SettingsCardProps {
  children: React.ReactNode;
  title: string | React.ReactNode;
  wrapClassName?: string;
  containerClassName?: string;
}

export const SettingsCard: React.FC<SettingsCardProps> = ({
  children,
  title,
  wrapClassName = "",
  containerClassName = "",
}) => {
  return (
    <div
      className={`bg-[#1438871A] rounded-[8px] p-1 w-full h-full flex flex-col ${containerClassName}`}
    >
      <h6 className="text-sm font-bold px-5 py-5 text-[#00032A]">{title}</h6>

      <div
        className={`bg-white px-6 py-8 rounded-[8px] flex-grow ${wrapClassName}`}
      >
        {children}
      </div>
    </div>
  );
};

